import type { Component } from "solid-js";
import type { IconProps } from "./types";

const WorkflowIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <polygon points="28,32.5 4,32.5 12.7,50 4,67.5 28,67.5 36.7,50" />
      <polygon points="57.7,32.5 33.7,32.5 42.3,50 33.7,67.5 57.7,67.5 66.3,50" />
      <polygon points="87.3,32.5 63.3,32.5 72,50 63.3,67.5 87.3,67.5 96,50" />
    </svg>
  );
};

export default WorkflowIcon;
